import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css";
import $ from "jquery";
import "datatables.net";

function OrderManagement() {
  const navigate = useNavigate();
  const location = useLocation();
  const [filter, setFilter] = useState("all");
  const [searchParams] = useSearchParams();
  const EventId = searchParams.get("id");

  const fetchData = async () => {
    try {
      const businessId = localStorage.getItem("business_id");
      const signupStatus = localStorage.getItem("signup");
      let params = {};
      if (businessId && signupStatus === "user") {
        params.business_id = businessId;
      }

      const response = await axios.get(
        process.env.REACT_APP_APIURL + "event/business/list",
        { params }
      );
      const events = response.data.result[0]?.events || [];

      // Fixed filtering logic
      const filteredEvents = filter === "all"
        ? events
        : events.filter((item) => {
          const purchaseStatus = item.purchase_status?.toLowerCase();
          const filterValue = filter.toLowerCase();

          // Handle the "paid" status mapping to "ordered"
          if (filterValue === "ordered") {
            return purchaseStatus === "paid" || purchaseStatus === "ordered";
          }

          return purchaseStatus === filterValue;
        });

      console.log("filteredEvents", filteredEvents);

      const orders = filteredEvents.map((item, index) => {
        // Helper function to get display status
        const getDisplayStatus = (purchaseStatus) => {
          const status = purchaseStatus?.toLowerCase();
          switch (status) {
            case 'paid':
              return 'Ordered';
            case 'active':
              return 'Active';
            case 'ordered':
              return 'Ordered';
            case 'delivered':
              return 'Delivered';
            case 'shipped':
              return 'Shipped';
            case 'cancelled':
              return 'Cancelled';
            default:
              return purchaseStatus || 'N/A';
          }
        };

        // Helper function to get status CSS class
        const getStatusClass = (purchaseStatus) => {
          const status = purchaseStatus?.toLowerCase();
          switch (status) {
            case 'paid':
            case 'ordered':
              return 'ordered';
            case 'active':
              return 'active';
            case 'delivered':
              return 'delivered';
            case 'shipped':
              return 'shipped';
            case 'cancelled':
              return 'cancelled';
            default:
              return 'default';
          }
        };
        const getDeliveryStatus = (trackingStatus) => {
          const status = trackingStatus?.toLowerCase();
          switch (status) {
            case 'ordered':
              return 'Order Confirmed';
            case 'packed':
              return 'Packed';
            case 'shipped':
              return 'In Transit';
            case 'out_for_delivery':
              return 'Out for Delivery';
            case 'delivered':
              return 'Delivered';
            case 'cancelled':
              return 'Cancelled';
            default:
              return 'Pending';
          }
        };

        const displayStatus = getDisplayStatus(item.purchase_status);
        const statusClass = getStatusClass(item.purchase_status);
        const deliveryStatus = getDeliveryStatus(item.current_tracking_status);

        return {
          orderId: `ORD00${index + 1}`,
          customerName: item.user_name || "N/A",
          orderDate: item.created_date
            ? new Date(item.created_date).toLocaleDateString()
            : "N/A",
          deliveryDate: item.event_date || "N/A",
          estimatedDelivery: item.estimated_delivery_date
            ? new Date(item.estimated_delivery_date).toLocaleDateString()
            : "N/A",
          actualDelivery: item.actual_delivery_date
            ? new Date(item.actual_delivery_date).toLocaleDateString()
            : "N/A",
          totalAmount: item.total_price ? `Rs. ${item.total_price}` : "N/A",
          paymentStatus: item.payment_status || "Pending",
          orderStatus: `<span class="status-text ${statusClass}">${displayStatus}</span>`,
          deliveryStatus: `<span class="delivery-status ${item.current_tracking_status || 'pending'}">${deliveryStatus}</span>`,
          trackingNumber: item.tracking_number || "N/A",
          courierService: item.courier_service || "N/A",
          shippingAddress: `${item.address || ""}, ${item.city || ""}, ${item.state || ""
            }, ${item.zip_code || ""}`.replace(/^,\s*|,\s*$/g, '').replace(/,\s*,/g, ','),
          contactDetails: item.phone_number || "N/A",
          paymentMethod: "Credit Card",
          shippingMethod: "Express Shipping",
          actions: `
      <button class="btn btn-sm btn-info view-order-btn" data-id="${item._id}">View</button>
    `,
        };
      });

      // Destroy existing DataTable if it exists
      if ($.fn.DataTable.isDataTable("#OrderManagement")) {
        $("#OrderManagement").DataTable().destroy();
      }

      $("#OrderManagement").DataTable({
        data: orders,
        columns: [
          { data: "orderId", title: "Order ID" },
          { data: "customerName", title: "Customer Name" },
          { data: "orderDate", title: "Order Date" },
          { data: "deliveryDate", title: "Event Date" },
          { data: "estimatedDelivery", title: "Est. Delivery" },
          { data: "totalAmount", title: "Total Amount" },
          { data: "paymentStatus", title: "Payment Status" },
          {
            data: "orderStatus",
            title: "Order Status",
            orderable: true,
            render: (data) => data,
          },
          {
            data: "deliveryStatus",
            title: "Delivery Status",
            orderable: true,
            render: (data) => data,
          },
          { data: "trackingNumber", title: "Tracking #" },
          { data: "courierService", title: "Courier" },
          { data: "shippingAddress", title: "Shipping Address" },
          { data: "contactDetails", title: "Contact Details" },
          { data: "actions", title: "Actions", orderable: false },
        ],
        destroy: true,
        responsive: true,
        autoWidth: false,
        paging: true,
        searching: true,
        lengthChange: true,
      });

      $("#OrderManagement").off("click", ".view-order-btn");
      $("#OrderManagement").on("click", ".view-order-btn", function () {
        const orderId = $(this).data("id");
        viewOrder(orderId);
      });

    } catch (error) {
      console.error("Error fetching order data:", error);
      alert("Failed to fetch order data. Please try again later.");
    }
  };

  const viewOrder = (orderId) => {
    navigate(`/ordermanagement_view?id=${orderId}`);
  };

  useEffect(() => {
    fetchData();

    return () => {
      if ($.fn.DataTable.isDataTable("#OrderManagement")) {
        $("#OrderManagement").DataTable().destroy();
      }
    };
  }, [filter]);

  return (
    <div className="wrapper" id="root">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">Order Management</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row mb-3">
              <div className="col-lg-12 d-flex justify-content-start gap-3 flex-wrap">
                <button
                  className={`btn btn-primary ${filter === "all" ? "active" : ""
                    }`}
                  onClick={() => setFilter("all")}
                >
                  All
                </button>
                <button
                  className={`btn btn-warning ${filter === "ordered" ? "active" : ""
                    }`}
                  onClick={() => setFilter("ordered")}
                >
                  Ordered
                </button>
                <button
                  className={`btn btn-secondary ${filter === "active" ? "active" : ""
                    }`}
                  onClick={() => setFilter("active")}
                >
                  Active
                </button>
                <button
                  className={`btn btn-success ${filter === "delivered" ? "active" : ""
                    }`}
                  onClick={() => setFilter("delivered")}
                >
                  Delivered
                </button>
                <button
                  className={`btn btn-info ${filter === "shipped" ? "active" : ""
                    }`}
                  onClick={() => setFilter("shipped")}
                >
                  Shipped
                </button>
                <button
                  className={`btn btn-danger ${filter === "cancelled" ? "active" : ""
                    }`}
                  onClick={() => setFilter("cancelled")}
                >
                  Cancelled
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive">
                  <table
                    id="OrderManagement"
                    className="table table-striped table-bordered txt_lft"
                    style={{ width: "100%" }}
                  ></table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default OrderManagement;